export const IS_UNSUPPORTED_BROWSER = !isBrowserSupported();

function isBrowserSupported() {
  return CSS && CSS.supports && CSS.supports('aspect-ratio: 1') && isBigIntSupported();
}

function isBigIntSupported() {
  try {
    BigInt(1n);
    return true;
  } catch {
    return false;
  }
}
